<template>
  <div style="padding-top: 75px">
    <div class="search plr15 bgfff">
      <van-row>
        <van-col span="20">
          <van-field
            v-model="value"
            left-icon="search"
            center
            @input="changeValue"
            clearable
            placeholder="搜索政策..."
          >
          </van-field>
        </van-col>
        <van-col span="4">
          <div @click="toBack" class="cancel">取消</div>
        </van-col>
      </van-row>
    </div>
    <div v-if="data.length" class="list_box">
      <div
        @click="toDtl(item.id)"
        class="list"
        v-for="(item, index) in data"
        :key="index"
      >
        <div class="title">{{ item.name }}</div>
      </div>
    </div>
    <div v-else class="empty">
      <img src="../images/noData.png" alt="" />
      <div class="tips" v-if="isSearch">
        <div>没有搜索结果</div>
        <div>请输入其他关键词试试</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: "",
      data: [],
      isSearch: false,
    };
  },
  methods: {
    toBack() {
      this.$router.go(-1);
    },
    changeValue(val) {
      this.isSearch = true;
      if (val != "") {
        this.$http.home
          .getPolicyList({
            classificationIds: null,
            currentPage: 1,
            pageSize: 999,
            queryDesc: 1,
            queryName: val,
            queryOrderBy: 1,
          })
          .then((res) => {
            if (res.data) {
              this.data = res.data.pageInfo.content;
            }
          });
      } else {
        this.data = [];
      }
    },
    // 查看详情
    toDtl(id) {
      this.$router.push(`/policyDetail/${id}`);
    },
  },
  created() {},
};
</script>
<style lang="less" scoped>
.search {
  position: fixed;
  top: 20px;
  left: 0;
  right: 0;
  .bgblue {
    background: #6d90e2;
    height: 20px;
  }

  .van-cell--center {
    box-shadow: 0px 4px 4px 0px rgba(210, 213, 217, 0.13);
    border-radius: 4px;
    border: 1px solid #e1e4eb;
    padding: 7px;
  }
  /deep/.van-icon-search {
    color: #323233;
  }

  .cancel {
    font-size: 14px;
    color: #6f8cf9;
    width: 60px;
    height: 40px;
    text-align: center;
    line-height: 40px;
  }
}
.list_box {
  padding: 0px 15px 15px 15px;
  .list {
    font-size: 14px;
    font-weight: 400;
    color: #515359;
    line-height: 22px;
    .title {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2; //行数
      -webkit-box-orient: vertical;
      padding: 10px 0;
      border-bottom: 1px solid #eee;
    }
  }
}
.empty {
  width: 100%;
  text-align: center;
  img {
    margin-top: 85px;
    width: 117px;
    height: 110px;
  }
  .tips div:nth-child(1) {
    font-size: 16px;
    font-weight: 600;
    color: #515359;
    line-height: 22px;
    margin-top: 20px;
    margin-bottom: 4px;
  }
  .tips div:nth-child(2) {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.5);
    line-height: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/search.vue